import React from 'react';

import Checkbox from '../../checkbox/Checkbox';
import CheckboxImg from '../../checkbox/CheckboxImg';
import './ReportChannelOption.css';

const ReportChannelOption = (props) => {
  return (
    <>
      {props.checkArray.map((item,index) => {
        if(item.id.substr(item.id.length-1) == "0"){
          return (
            <div className="report-channel">
              <CheckboxImg labelName={item.name} className="channel-list-checkbox" checked={item.checked} id={`subChannel-checkbox-${item.id}`} handleCheckBox={props.handleCheckBox}/>
              {/* <span>{item.name}</span> */}
            </div>
          )
        }
        else {
          return (
            <div className="report-sub-channel">
              <CheckboxImg labelName={item.name} className="channel-list-checkbox" checked={item.checked} id={`subChannel-checkbox-${item.id}`} handleCheckBox={props.handleCheckBox}/>
              {/* <span>{item.name}</span> */}
            </div>
          )
        }
      })}
    </>
  )
}

export default ReportChannelOption;